/**
 * Per-tab localStorage helpers for Stops Management UI prefs (Q7).
 *
 * Two values are persisted on the user's browser:
 *  - `stops:legend`     -> array of category keys hidden from the map legend
 *  - `stops:showAreas`  -> boolean toggle for rendering polygons / radii
 *
 * Reads are defensive: a malformed value is treated as "no preference" rather
 * than throwing.
 */

const KEY_LEGEND = 'stops:legend';
const KEY_SHOW_AREAS = 'stops:showAreas';

function safeStorage() {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return null;
    return window.localStorage;
  } catch (e) {
    return null;
  }
}

export function loadHiddenCategories() {
  const storage = safeStorage();
  if (!storage) return [];

  try {
    const raw = storage.getItem(KEY_LEGEND);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((k) => typeof k === 'string') : [];
  } catch (e) {
    return [];
  }
}

export function saveHiddenCategories(categories) {
  const storage = safeStorage();
  if (!storage) return;

  try {
    const list = Array.isArray(categories) ? categories.filter((k) => typeof k === 'string') : [];
    storage.setItem(KEY_LEGEND, JSON.stringify(list));
  } catch (e) {
    // ignore quota / privacy mode errors
  }
}

export function loadShowAreas(defaultValue = true) {
  const storage = safeStorage();
  if (!storage) return defaultValue;

  try {
    const raw = storage.getItem(KEY_SHOW_AREAS);
    if (raw === null) return defaultValue;
    return raw === '1' || raw === 'true';
  } catch (e) {
    return defaultValue;
  }
}

export function saveShowAreas(value) {
  const storage = safeStorage();
  if (!storage) return;

  try {
    storage.setItem(KEY_SHOW_AREAS, value ? '1' : '0');
  } catch (e) {
    // ignore
  }
}

export default {
  loadHiddenCategories,
  saveHiddenCategories,
  loadShowAreas,
  saveShowAreas,
};
